<template>
  <div v-if="limitMaxReachedInCollection > 0" class="limitMaxReachedInCollection">
    <div>
    {{ t('searchMaxLimitReachedText1') }}
    </div>
    <div>
    {{ t('searchMaxLimitReachedText2') }}
    </div>
  </div>
</template>

<script lang="ts">
import { toRefs, reactive, computed } from "vue";
import { useDocumStore } from "@/engineproject/store/documStore";
import { useI18n } from "@/engineproject/default/common/i18n";

export default {
  props: {
    adDocFileType: {
      type: String,
      required: false,
      default: ""
    },
  },
  name:"DashboardSearchAndListView",
  setup(props: any) {
    const documStore = useDocumStore();

    const { t } = useI18n();
    const page = reactive({
      limitMaxReachedInCollection: computed(() => documStore.state.limitMaxReachedInCollection),
    });

    return {
      ...toRefs(page),
      t
    };
  },
  components: { 
  },
};
</script>

